import enrollmentExperimentAmplitude from './enrollmentExperiment'
import featureFlagExperiment from './featureFlagExperiment'

export * from './experiment'

const enrollmentExperiment = import.meta.env.VITE_AMPLITUDE_API_KEY
    ? enrollmentExperimentAmplitude
    : featureFlagExperiment

export { enrollmentExperiment }
